interface Props {
  matchCount?: number;
}
export function HeaderLogo({ matchCount }: Props) {
  return (
    <div className="rounded-full px-2 py-0.5 bg-black flex gap-1 items-center justify-center">
      <span className="text-white">poke</span>
      {matchCount ? <span className="text-gray-400">{matchCount}</span> : null}
    </div>
  );
}
